<div class="flex items-start overflow-auto my-2 md:my-0">
    @for (status of statusOptions(); track status; let i = $index) {
        <!-- Desktop view -->
        <div class="hidden md:flex flex-1 flex-col items-center">
            <div class="flex items-center w-full">
                <div class="flex-1 border-t-2 border-b-0 border-x-0 border-solid border-shui-text-disabled"></div>
                <button
                    class="flex flex-col items-center bg-transparent border-none cursor-pointer p-0"
                    [class.cursor-not-allowed]="disabled()"
                    [class.pointer-events-none]="disabled()"
                    [class.opacity-50]="disabled()"
                    (click)="toggle(status)"
                >
                    <div
                        class="w-10 h-10 rounded-full border-8 border-solid border-shui-base-2 flex items-center justify-center shrink-0"
                        [class.bg-shs-orange]="!disabled() && isActive(status)"
                        [class.bg-shui-base-4]="disabled() || !isActive(status)"
                    ></div>
                </button>
                <div class="flex-1 border-t-2 border-b-0 border-x-0 border-solid border-shui-text-disabled"></div>
            </div>
            <button
                class="bg-transparent border-none cursor-pointer p-0 pt-2.5 -mt-2"
                [class.cursor-not-allowed]="disabled()"
                [class.pointer-events-none]="disabled()"
                [class.opacity-50]="disabled()"
                (click)="toggle(status)"
            >
                <span class="text-shui-text-strong text-sm font-semibold whitespace-nowrap">
                    {{ 'common.status.internal.' + status | translate }}
                </span>
            </button>
        </div>

        <!-- Mobile view -->
        <button
            class="block md:hidden px-4 py-1 mx-1 rounded-sm text-shui-text-strong text-sm font-semibold border-none max-w-full whitespace-nowrap"
            [class.bg-shs-orange]="!disabled() && isActive(status)"
            [class.bg-shui-base-2]="disabled() || !isActive(status)"
            [class.opacity-50]="disabled()"
            (click)="toggle(status)"
        >
            {{ 'common.status.internal.' + status | translate }}
        </button>
    }
</div>
